module.exports = __webpack_public_path__ + "img/take-measurements.7aa016cd.svg";